import { render, staticRenderFns } from "./selectedJobCard.vue?vue&type=template&id=68a7d6b2&scoped=true"
import script from "./selectedJobCard.vue?vue&type=script&lang=js"
export * from "./selectedJobCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a7d6b2",
  null
  
)

export default component.exports